var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mt-2 holiday_title text-xl"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"list-group"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }